import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export function BlogIndex() {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/blog").then(({ data }) => setItems(data.items)); }, []);

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16" data-testid="blog-index">
      <div className="label-eyebrow mb-3">Journal</div>
      <h1 className="text-5xl sm:text-6xl font-black tracking-tight font-display-ai max-w-3xl">
        Field notes from the <span className="text-[#00FFC2]">forge.</span>
      </h1>
      <p className="text-gray-400 mt-5 max-w-2xl leading-relaxed">
        What we're learning from running the academy and the studio in parallel.
      </p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className="glass rounded-xl overflow-hidden group" data-testid={`blog-card-${p.slug}`}>
            <div className="aspect-[16/10] overflow-hidden">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover transition duration-700 group-hover:scale-110" />
            </div>
            <div className="p-5">
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#A855F7] mb-2">{p.tag} · {p.read_minutes} min</div>
              <div className="text-lg font-semibold">{p.title}</div>
              <div className="text-sm text-gray-400 mt-2">{p.excerpt}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { http.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setPost(false)); }, [slug]);

  if (post === null) return <div className="p-20 text-center text-gray-500">Loading…</div>;
  if (post === false) return <div className="p-20 text-center text-gray-500">Not found.</div>;

  return (
    <article className="max-w-[820px] mx-auto px-6 lg:px-10 py-16" data-testid={`blog-post-${slug}`}>
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white mb-8">
        <ArrowLeft size={14} /> Back to Journal
      </Link>
      <div className="text-[10px] tracking-[0.25em] uppercase text-[#A855F7] mb-3">{post.tag} · {post.read_minutes} min read</div>
      <h1 className="text-4xl sm:text-5xl font-black tracking-tight font-display-ai leading-[1.05]">{post.title}</h1>
      <div className="aspect-[16/9] mt-8 overflow-hidden rounded-xl">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
      </div>
      <div className="prose prose-invert mt-8 max-w-none text-gray-200 leading-relaxed whitespace-pre-wrap">
        {post.body}
      </div>
    </article>
  );
}
